var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlinePenAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.721 14-5.67-5.67a.742.742 0 0 1-.1-.93l1.77-2.8c.48-.77 1.23-1.24 2.09-1.34.95-.11 1.96.28 2.74 1.06l3.18 3.18c.75.75 1.12 1.75 1.01 2.75-.1.87-.56 1.62-1.28 2.08l-2.8 1.77c-.13.08-.27.12-.41.12-.19 0-.39-.08-.53-.22zm.64-1.48 2.29-1.45c.34-.21.55-.56.59-.98.06-.53-.16-1.1-.58-1.52l-3.18-3.18c-.46-.46-1.01-.69-1.51-.63-.4.04-.74.27-.98.65l-1.45 2.29 4.82 4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24 21.8c-.72-.72-1.04-1.73-.91-2.85l.98-8.28c.05-.41.42-.7.83-.66.41.05.71.42.66.83l-.98 8.28c-.08.65.09 1.22.48 1.61.39.39.97.57 1.63.49l8.72-1.03c1.86-.22 2.27-.72 2.09-2.54l-.24-4.15a.75.75 0 1 1 1.5-.08l.24 4.12c.26 2.58-.76 3.83-3.41 4.15l-8.72 1.03c-.16.02-.32.03-.48.03-.94 0-1.77-.33-2.39-.95zM12.53 8.56l-1.75-.11a.75.75 0 0 1-.7-.8c.03-.42.38-.73.8-.7l1.75.11c.41.03.73.38.7.8a.76.76 0 0 1-.75.7h-.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 21.31a.755.755 0 0 1 0-1.06l3.18-3.18c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.18 3.18c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81 11.47a5.204 5.204 0 0 1-2.8-2.26c-.5-.82-.76-1.76-.76-2.71 0-1.62.72-3.11 1.98-4.1.92-.74 2.08-1.15 3.27-1.15 2.9 0 5.25 2.36 5.25 5.25 0 .47-.07.96-.2 1.41-.13.46-.31.88-.56 1.3-.29.48-.64.89-1.05 1.24-.94.84-2.16 1.3-3.44 1.3-.59 0-1.16-.1-1.69-.28zm-.65-7.9c-.9.71-1.41 1.77-1.41 2.93 0 .67.19 1.34.54 1.93.46.76 1.17 1.34 2 1.61 1.21.43 2.66.16 3.67-.73.29-.25.54-.55.75-.88a3.83 3.83 0 0 0 .54-1.93 3.751 3.751 0 0 0-6.09-2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77 8.18V4.82c0-.41.34-.75.75-.75s.75.34.75.75v3.36a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 7.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.36a.749.749 0 1 1 0 1.5H4.8z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePenAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-pen-add.36f421b097c1a019a92f8ade703d8cef.svg";
export { ForwardRef as ReactComponent };